module.exports = __webpack_public_path__ + "static/media/music.[p=1].eff0ab47.mp3";